/** @var themeVars */

document.addEventListener("DOMContentLoaded",function() {

  /* Load more post
  **************************************************************/
  const btnMore = document.querySelector('.btn-more');

  if(btnMore !== null) {
    btnMore.addEventListener('click', function () {
      btnMore.classList.add('hide');
      const container = document.querySelector('.container__grid .content-list');
      let offset = container.getAttribute('data-offset');
      let total = container.getAttribute('data-total');
      let category = container.getAttribute('data-category');

      const formData = new FormData();
      formData.append('action', 'get_more_posts');
      formData.append('offset', offset);
      formData.append('category', category);


      fetch(themeVars.ajaxurl, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
            return response.text()
        })
        .then((data) => {
          offset = Number(offset) + 3;
          offset < total ? btnMore.classList.remove('hide') : '';
          container.setAttribute('data-offset', offset);
          container.insertAdjacentHTML('beforeend', data);
        })
    })
  }


  let btnMoreToolkit = document.querySelector('.btn-more-toolkit');
  let filter = document.querySelector(`[name='filter']`);
  /* Load toolkit by click
  **************************************************************/
  if(btnMoreToolkit !== null) {
    btnMoreToolkit.addEventListener('click', function (e) {
      getToolkit(e.type);
    })
  }

  /* Load toolkit Language changed
  **************************************************************/
  if (filter !== null) {
    filter.addEventListener("change", function(e) {
      getToolkit(e.type);
    });
  }

  /* Load toolkit
  **************************************************************/
  function getToolkit(type) {
    btnMoreToolkit.classList.add('hide');
    let term_id, term_count, container;
    let isArchive = document.body.classList.contains('tax-types') ? true : false;

    if(isArchive) {
      container = document.querySelector('.container__grid .content-list');
      term_id = container.getAttribute('data-category');
    } else {
      term_id = filter.options[filter.selectedIndex].value;
      term_count = filter.options[filter.selectedIndex].getAttribute('data-count');
      container = document.querySelector('.container__grid_toolkit .content-list');
    }

    let offset = type === 'click' ?  container.getAttribute('data-offset') : 0;
    let total = container.getAttribute('data-total');

    const formData = new FormData();
    formData.append('action', 'get_toolkit');
    formData.append('offset', offset);
    formData.append('term_id', term_id);

    if(type === 'change') {
      container.querySelectorAll(`.toolkit-card`).forEach(item => {
        item.remove();
      });
    }
    fetch(themeVars.ajaxurl, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
          return response.text()
      })
      .then((data) => {
        offset = Number(offset) + 3;
        if(type === 'click' || isArchive) {
          offset < total ? btnMoreToolkit.classList.remove('hide') : '';
        } else {
          offset < term_count ? btnMoreToolkit.classList.remove('hide') : '';
        }
        container.setAttribute('data-offset', offset);
        container.insertAdjacentHTML('beforeend', data);
      })
  }

  /* Load activities on click
  **************************************************************/
  let btnMoreActivities = document.querySelectorAll('.btn-more-activities');

  btnMoreActivities && btnMoreActivities.forEach(btn =>
    btn.addEventListener('click', (e) => getActivities(e)))

  /* Load activities
    **************************************************************/
  function getActivities(e) {
    let type, offset, total, container;

    const currentBtn = e.currentTarget;
    const containerWrapper = e.currentTarget.closest('.container__grid');

    currentBtn.classList.add('hide');
    container = containerWrapper.querySelector('.content-list');

    type = container.dataset.type;
    offset = container.dataset.offset;
    total = container.dataset.total;

    const formData = new FormData();

    formData.append('action', 'get_activities');
    formData.append('offset', offset);
    formData.append('type', type);

    fetch(themeVars.ajaxurl, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
        return response.text()
    })
    .then((data) => {
      offset = Number(offset) + 3;
      offset < total ? currentBtn.classList.remove('hide') : '';

      container.setAttribute('data-offset', offset);
      container.insertAdjacentHTML('beforeend', data);
    })
  }
})



// WEBPACK FOOTER //
// ./scripts/modules/ajax.js